export default __webpack_public_path__ + "static/media/mtt_chrispopescu.4e8f31ec.jpg";